import { PROMOTION_ADD, RESET_STATE } from "../constants/actionTypes";

const INITIAL_STATE = {
  promotions: [],
};

const applyPromotions = (state, action) => ({
  ...state,
  promotions: action.payload,
});

const promotionReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case PROMOTION_ADD:
      return applyPromotions(state, action);
    case RESET_STATE:
      return INITIAL_STATE;
    default:
      return state;
  }
};

export default promotionReducer;
